module.exports = require("./os-GE");